import axios from "axios";
import { URL } from "../../api/tklEnvironments";
import { types } from "../../reducers/types";
import { sortBasedonSortOrder } from "./UserAction";
export const getPositionTitlesMasterData = (page) => {
  return (dispatch) => {
    dispatch({ type: types.IS_LOADING, payload: true });
    let userData = JSON.parse(sessionStorage.getItem("userSortingData"));
    // !userData?.searchInput
    if (true) {
      dispatch(
        sortBasedonSortOrder(
          "get-positions",
          1,
          "position",
          userData?.sortFieldType?.slug || "title",
          userData?.sortOrder === "Descending" ? "DESC" : "ASC" || "ASC",
          "",
          "",
          false,
          page
        )
      );
    } else {
      axios
        .get(`${URL}/get-positions?page=${page}`)
        .then(function (response) {
          if (response.data) {
            dispatch({ type: types.IS_LOADING, payload: false });
            dispatch({ type: types.IS_RELOAD, payload: false });
            dispatch({
              type: types.GET_POSITION_TITLES_MASTER_DATA,
              payload: response.data,
            });
          }
        })
        .catch(function (error) {
          dispatch({ type: types.IS_LOADING, payload: false });
          console.error("..error", error);
        });
    }
  };
};

export const updatePositionTitle = (payload) => {
  return (dispatch) => {
    axios
      .put(`${URL}/update-position`, payload)
      .then(function (response) {
        if (response.data) {
          dispatch({ type: types.IS_RELOAD, payload: true });
        }
      })
      .catch(function (error) {
        console.error("..error", error);
        let errorMessage = error.response?.data?.errors?.name;
        if (
          errorMessage &&
          errorMessage[0] === "The name has already been taken."
        ) {
          dispatch({
            type: types.API_ERROR,
            payload: "The name has already been taken.",
          });
        }
      });
  };
};

export const addPositionTitle = (payload) => {
  return (dispatch) => {
    axios
      .post(`${URL}/add-position`, payload)
      .then(function (response) {
        if (response.data) {
          dispatch({ type: types.IS_RELOAD, payload: true });
        }
      })
      .catch(function (error) {
        console.error("..error", error);
        let errorMessage = error.response?.data?.errors?.name;
        if (
          errorMessage &&
          errorMessage[0] === "The name has already been taken."
        ) {
          dispatch({
            type: types.API_ERROR,
            payload: "The name has already been taken.",
          });
        }
      });
  };
};
